// extracted by mini-css-extract-plugin
export default {"box":"empty_box__Cm6fO","heading":"empty_heading__ZYrE0","text":"empty_text__8I7dV"};